/*
 * eslint-disable -- o AppLink ja encapsula WLink.
 */
/* eslint-disable @alice-health/w-link */

import { Link } from '@/global/components/Link'
import { WParagraph } from '@alice-health/wonderland-react'
import { NavbarDrawerGroup as Group } from './Navbar.types'
import { sendButtonClickedAnalyticEvent } from './Navbar.helpers'

interface NavbarDrawerGroupProps {
  group: Group
  onNavigate: () => void
}

const NavbarDrawerGroup = ({
  group: { title, links },
  onNavigate
}: NavbarDrawerGroupProps) => (
  <div className='flex flex-col gap-gl-spacing-02'>
    {/*
     * O rotulo e a mesma cor dos links a 40% de opacidade, como em producao.
     * Nenhum `mode` do design system chega neste tom: os neutros dele
     * (`secondary` #585858, `tertiary` #6f6f6f) sao cinzas, e o rotulo e um
     * magenta dessaturado. A opacidade fica no wrapper, nao no componente,
     * para nao mexer no `class` do host.
     *
     * `size='medium'` le `--gl-font-size-md`, que da os 14px da referencia. O
     * `WHelper`, que seria o componente de texto auxiliar, e fixo em 12px.
     */}
    <div className='opacity-40'>
      <WParagraph
        mode='active'
        size='medium'
      >
        {title}
      </WParagraph>
    </div>

    {links.map(link => (
      <div
        key={link.title}
        /*
         * O texto anda 8px para a direita no hover, junto com a troca de cor,
         * como o `transition: color .2s, margin-left .2s` de producao. O recuo
         * e `padding`, e nao `margin`: assim a area de hover cresce em vez de
         * andar, e o ponteiro nao sai dela no meio do movimento.
         */
        className='navbar-panel-link-type w-fit transition-[padding] duration-200 hover:pl-gl-spacing-02'
      >
        <Link
          as='link'
          quiet
          variant='primary'
          size='medium'
          href={link.href}
          onClick={() => {
            sendButtonClickedAnalyticEvent(link.title)
            onNavigate()
          }}
        >
          {link.title}
        </Link>
      </div>
    ))}
  </div>
)

export { NavbarDrawerGroup }
